function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".markArtifactVersionAsBad_svg__e{fill:none;stroke:#191816;stroke-linejoin:round;stroke-linecap:round}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 39,
  fill: "#ff8787"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#aa8d72",
  d: "M30.2 40.6l5.9-11.1h27.4l6.3 11.3-39.6-.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 40.4h36.6a1.538 1.538 0 011.5 1.5v26.6a1.538 1.538 0 01-1.5 1.5H31.5a1.538 1.538 0 01-1.5-1.5V41.9a1.473 1.473 0 011.5-1.5z",
  fill: "#f0d5a8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "markArtifactVersionAsBad_svg__e",
  d: "M63.6 29.5l6.2 11.3v27.7a1.538 1.538 0 01-1.5 1.5H31.5a1.538 1.538 0 01-1.5-1.5V40.7l6.2-11.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  strokeLinecap: "round",
  stroke: "#191816",
  strokeLinejoin: "round",
  d: "M50.2 57.3h13.2v6.3H50.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "markArtifactVersionAsBad_svg__e",
  d: "M30 40.7h39.7M49.8 29.6v11"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M79.7 46.7a1.872 1.872 0 000-2.6l-5.2-5.2a.854.854 0 010-1.3l5.2-5.2a1.872 1.872 0 000-2.6l-3.3-3.3a1.872 1.872 0 00-2.6 0l-5.2 5.2a.853.853 0 01-1.3 0L62 26.4a1.872 1.872 0 00-2.6 0l-3.3 3.3a1.872 1.872 0 000 2.6l5.2 5.2a.854.854 0 010 1.3L56.1 44a1.872 1.872 0 000 2.6l3.3 3.3a1.872 1.872 0 002.6 0l5.2-5.2a.853.853 0 011.3 0l5.2 5.2a1.872 1.872 0 002.6 0z",
  fill: "#ff6242"
}), React.createElement("path", {
  d: "M73.8 26.4l-5.2 5.2a.853.853 0 01-1.3 0L62 26.4a1.872 1.872 0 00-2.6 0l-3.3 3.3a1.872 1.872 0 000 2.6l5.2 5.2a.854.854 0 010 1.3L56.1 44a1.872 1.872 0 000 2.6l2 2 20.4-20.3-2-2a2.003 2.003 0 00-2.7.1z",
  fill: "#ff866e"
}), React.createElement("path", {
  d: "M79.7 46.7a1.872 1.872 0 000-2.6h0l-5.2-5.2a.854.854 0 010-1.3l5.2-5.2a1.872 1.872 0 000-2.6h0l-3.3-3.3a1.872 1.872 0 00-2.6 0l-5.2 5.2a.853.853 0 01-1.3 0L62 26.4a1.872 1.872 0 00-2.6 0l-3.3 3.3a1.872 1.872 0 000 2.6h0l5.2 5.2a.854.854 0 010 1.3L56.1 44a1.872 1.872 0 000 2.6h0l3.3 3.3a1.872 1.872 0 002.6 0h0l5.2-5.2a.853.853 0 011.3 0l5.2 5.2a1.872 1.872 0 002.6 0h0z",
  stroke: "#191816",
  strokeLinejoin: "round",
  fill: "none"
}));

function SvgMarkArtifactVersionAsBad(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, React.createElement("path", {
    d: "M30 56.7l16.3-16.3H32a2.006 2.006 0 00-2 2z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff5e3",
    opacity: 0.7
  }), _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "markArtifactVersionAsBad.70fac.svg";
export { SvgMarkArtifactVersionAsBad as ReactComponent };